module.exports = __webpack_public_path__ + "606b9debbcc4f00cb3533bfc46732ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pages/arrow.png
// module id = 1128
// module chunks = 73